import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { emptyState } from "../../lib/engine";
import CityEditor from "../CityEditor";

// Editor Kota untuk admin — bisa mengedit SEMUA kota lewat pill pemilih kota
export function AdminCityEditor({ token }) {
  const [cities, setCities] = useState([]);
  const [cityId, setCityId] = useState(null);

  useEffect(() => {
    api.adminCities(token)
      .then(d => {
        const list = d.cities || [];
        setCities(list);
        if (list.length && !cityId) setCityId(list[0].city_id);
      })
      .catch(() => {});
  }, [token]); // eslint-disable-line

  if (!cities.length) return <p style={{ padding: 24, color: "#94a3b8" }}>Memuat daftar kota...</p>;
  const current = cities.find(c => c.city_id === cityId);

  const pills = (
    <div data-testid="admin-city-pills" style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
      {cities.map(c => (
        <button key={c.city_id} data-testid={`city-pill-${c.city_id}`} onClick={() => setCityId(c.city_id)}
          style={{
            padding: "7px 14px", borderRadius: 99, fontSize: 12, fontWeight: 600, textTransform: "capitalize",
            border: 0,
            background: cityId === c.city_id ? "#141414" : "transparent",
            color: cityId === c.city_id ? "#fff" : "#141414", transition: "background-color 0.15s", cursor: "pointer",
            fontFamily: "'Plus Jakarta Sans', sans-serif"
          }}>
          {c.city_name}
        </button>
      ))}
    </div>
  );

  return (
    <CityEditor
      key={cityId}
      isAdmin
      token={token}
      title={current?.city_name || cityId}
      headerExtra={pills}
      loadState={() => api.adminGetCityState(token, cityId).then(s => s.state || emptyState())}
      saveState={(st) => api.adminSaveCityState(token, cityId, st)}
    />
  );
}
